import React from 'react';
import { Sparkles, Lock, ArrowRight } from 'lucide-react';

interface ProTeaserBannerProps {
  title: string;
  subtitle?: string;
  onUpgrade?: () => void;
}

export const ProTeaserBanner: React.FC<ProTeaserBannerProps> = ({
  title,
  subtitle = 'Unlock comprehensive multi-year historical telemetry, export tools, and AI anomaly tracking.',
  onUpgrade
}) => {
  return (
    <div className="rounded-3xl p-5 sm:p-6 bg-gradient-to-r from-slate-900 via-blue-950 to-slate-900 text-white border border-blue-900/40 shadow-lg relative overflow-hidden my-4">
      {/* Background glow */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 relative z-10">
        <div className="flex items-start gap-3.5">
          <div className="w-10 h-10 rounded-2xl bg-blue-600/30 border border-blue-400/30 flex items-center justify-center text-blue-300 flex-shrink-0">
            <Lock className="w-5 h-5" strokeWidth={2} />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-black uppercase tracking-wider bg-blue-500/20 text-blue-300 px-2 py-0.5 rounded-full border border-blue-400/30">
                PRO INTELLIGENCE
              </span>
            </div>
            <h4 className="text-sm sm:text-base font-bold text-white mt-1">
              {title}
            </h4>
            <p className="text-xs text-slate-300 mt-0.5 max-w-xl">
              {subtitle}
            </p>
          </div>
        </div>

        <button
          onClick={onUpgrade}
          className="px-4 py-2.5 rounded-2xl text-xs font-bold bg-blue-600 hover:bg-blue-500 text-white transition-all shadow-md flex items-center justify-center gap-2 flex-shrink-0 cursor-pointer self-start sm:self-center"
        >
          <Sparkles className="w-3.5 h-3.5" />
          <span>Unlock with Pro</span>
          <ArrowRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};
